import React from 'react'

import InternalServerError from '../components/Error/InternalServerError'
import Newsletter from '../components/Newsletter'
import { logServerSidePropsError } from '../components/utilities/log-helper'
import regions from '../config/regions'
import { STATUS_CODE } from '../data/enums/statusCodes'
import fetchNewslettersList, { NewslettersList } from '../data/query/fetchNewslettersList'
import { RouteRedMetrics } from '../utils/metrics'

interface NewsletterProps {
  error?: boolean
  newsletters?: NewslettersList
}

export default ({ error, newsletters }: NewsletterProps) => {
  if (error) {
    return <InternalServerError />
  }
  return <Newsletter newsletters={newsletters} />
}

export async function getServerSideProps(context) {
  const redMetrics = new RouteRedMetrics({
    method: 'GET',
    route: 'newsletter'
  }).start()

  try {
    const regionName = context?.req?.headers?.host?.split('.')?.[0]
    const regionId = regions[regionName]?.contentfulId || regions.default.contentfulId
    const { statusCode, data } = await fetchNewslettersList(regionId)

    if (statusCode !== STATUS_CODE.success && statusCode !== STATUS_CODE.notFound) {
      redMetrics.end({
        status: statusCode,
        error: 'Newsletter page error'
      })
      context.res.statusCode = STATUS_CODE.internalServerError
      return {
        props: { error: true }
      }
    }

    if (statusCode === STATUS_CODE.notFound || !data) {
      redMetrics.end({
        status: STATUS_CODE.notFound,
        error: 'Newsletter page data not found'
      })

      return { notFound: true }
    }

    const surrogateKeyHeader = context?.res?.getHeader('Surrogate-Key')?.split(' ')
    const surrogateKeys = [...surrogateKeyHeader, data?.entryId].filter(Boolean).join(' ')
    context?.res?.setHeader('Surrogate-Key', surrogateKeys)

    redMetrics.end({
      status: STATUS_CODE.success
    })

    return {
      props: {
        newsletters: data?.list
      }
    }
  } catch (error) {
    logServerSidePropsError(error)
    redMetrics.end({
      status: STATUS_CODE.internalServerError,
      error: 'Failed to load Newsletter page data'
    })

    context.res.statusCode = STATUS_CODE.internalServerError
    return { props: { error: true } }
  }
}
